import PageSection from '@app/components/PageSection'
import { IAssociatedListing } from '@app/models/AssociatedListing'
import { ListingStatus } from '@app/models/enums'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import AssociatedListingCard from './AssociatedListingCard'
import { PropertyPageProps } from './PropertyPage'

export default class PropertyListings extends React.PureComponent<
  PropertyPageProps
> {
  public render() {
    return (
      <DocumentTitle title={`${this.props.property.name} :: Listings`}>
        {this.props.property.listings.size === 0
          ? this._renderNoListings()
          : this._renderListings()}
      </DocumentTitle>
    )
  }

  private _renderNoListings() {
    return <div>No listings found</div>
  }

  private _renderListings() {
    const activePendingList: IAssociatedListing[] = []
    const soldList: IAssociatedListing[] = []
    const inactiveList: IAssociatedListing[] = []

    this.props.property.listings.forEach((l) => {
      if (l !== undefined) {
        switch (l.status) {
          case ListingStatus.Active:
          case ListingStatus.Pending:
            activePendingList.push(l)
            break

          case ListingStatus.Sold:
            soldList.push(l)
            break

          default:
            inactiveList.push(l)
            break
        }
      }
    })

    return (
      <div>
        <PageSection title='Active / Pending'>
          {activePendingList.length > 0
            ? this._renderListingsList(activePendingList)
            : this._renderNoListingsForType('active or pending')}
        </PageSection>
        <PageSection title='Sold'>
          {soldList.length > 0
            ? this._renderListingsList(soldList)
            : this._renderNoListingsForType('sold')}
        </PageSection>
        <PageSection title='Expired / Inactive'>
          {inactiveList.length > 0
            ? this._renderListingsList(inactiveList)
            : this._renderNoListingsForType('inactive or expired')}
        </PageSection>
      </div>
    )
  }

  private _renderListingsList(listings: IAssociatedListing[]) {
    return (
      <div className='detail-card-group'>
        {listings.map((l) => (
          <div className='detail-card' key={l.listingId}>
            <AssociatedListingCard listing={l} />
          </div>
        ))}
      </div>
    )
  }

  private _renderNoListingsForType(type: string) {
    return <div>No {type} listings</div>
  }
}
